import type { AiMessage } from "../../../common/ai/AiDraftModal";

export type NeedDescriptionPromptInput = {
  title: string;
  currentDescription: string;
  language: "no" | "en";
};

export const buildNeedDescriptionMessages = ({
  title,
  currentDescription,
  language,
}: NeedDescriptionPromptInput): AiMessage[] => {
  const outputLanguage = language === "no" ? "Norwegian (Bokmål)" : "English";
  return [
    {
      role: "SYSTEM",
      content: [
        "You are a procurement adviser for a Norwegian public-sector organisation helping a colleague describe a procurement need (behov).",
        `Write the description in ${outputLanguage}.`,
        "Use Markdown: a short intro paragraph, then bullet points for scope, background and any known requirements.",
        "Be concrete, precise and professional.",
        "Keep all relevant information from the current description and build on it rather than discarding it.",
        "Do not invent specifics you have no basis for — no fabricated dates, budgets, volumes or brand names.",
        "Output only the description itself, with no preamble or closing remarks.",
      ].join(" "),
    },
    {
      role: "USER",
      content: [
        `Title: ${title || "(no title)"}`,
        `Current description:\n${currentDescription || "(empty)"}`,
      ].join("\n\n"),
    },
  ];
};
